var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('article',{staticClass:"looks-item",class:{'looks-item--selected': _vm.selected}},[_c('look-dynamic-card',{attrs:{"look":_vm.item,"size":"small","selected":_vm.selected}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }